import React from 'react';

const SingaporeAIGov = () => (
  <article className="news-article-body">
    <p className="news-lead">
      Singapore's AI governance story is one of the more coherent ones globally. While
      the EU focused on restrictions and the US struggled with fragmented regulation,
      Singapore spent years building practical frameworks, testing tools in sandboxes,
      and positioning itself as a trusted hub for companies that want to do AI responsibly
      in Asia. The centerpiece of that work is the Model AI Governance Framework, first
      released in 2019 and significantly updated in 2024.
    </p>

    <h2>The Singapore approach - pragmatic, not prohibitive</h2>
    <p>
      Singapore's strategy has always been to enable AI while managing risk - rather than
      treating every AI application as a potential threat until proven otherwise. The Model
      AI Governance Framework gives companies voluntary but detailed guidance on:
    </p>
    <ul>
      <li>How to assess and document AI risks</li>
      <li>How to ensure human oversight in high-stakes decisions</li>
      <li>How to handle bias, fairness, and data privacy</li>
      <li>How to maintain explainability standards for regulated industries</li>
    </ul>
    <p>
      The voluntary nature was deliberate - IMDA (the Infocomm Media Development Authority)
      wanted to build trust with industry before mandating compliance. The approach has worked:
      Singapore consistently ranks among the world's top AI-ready nations.
    </p>

    <h2>Using AI to fight AI-enabled fraud</h2>
    <p>
      Singapore's law enforcement has increasingly used AI tools to combat scams and financial
      fraud - a major problem across Southeast Asia. The Singapore Police Force and IMDA have
      collaborated on tools that can detect fraud patterns in communications, flag suspicious
      financial flows, and identify deepfake content used in scam calls.
    </p>
    <p>
      <em>Note: Reports of specific multi-billion-dollar fraud prevention figures associated
      with AI tools should be verified against official SPF and MAS statistics - we haven't
      been able to confirm specific headline figures cited in some media coverage.</em>
    </p>

    <h2>Project Moonshot - testing AI safety at scale</h2>
    <p>
      One of Singapore's more practical contributions is <strong>Project Moonshot</strong>,
      an open-source toolkit released in 2024 for benchmarking and red-teaming AI systems.
      It lets organisations test AI models against known attack patterns, measure reliability,
      and evaluate how models behave under adversarial conditions.
    </p>
    <p>
      The toolkit is free and designed to be used by companies before they deploy AI in
      production. It's a concrete, usable tool rather than just a policy document - and
      that's exactly the kind of thing that makes Singapore's governance approach respected
      internationally.
    </p>

    <h2>The 2024 agentic AI update</h2>
    <p>
      Recognising that AI agents capable of taking autonomous actions posed different risks
      than passive language models, Singapore updated its governance framework in 2024 to
      specifically address agentic AI. The update covers:
    </p>
    <ul>
      <li>How to maintain human oversight when an AI agent makes decisions autonomously</li>
      <li>Accountability chains when multiple AI agents work together</li>
      <li>Minimum documentation requirements for agentic deployments in critical sectors</li>
    </ul>

    <div className="news-insight-box">
      <h3>The big lesson</h3>
      <p>
        Singapore's governance model shows that regulation and innovation aren't automatically
        in conflict. By building practical tools, maintaining strong industry dialogue, and
        focusing on enablement rather than prohibition, Singapore has become a destination for
        companies that want a clear, stable environment to develop AI. The rest of Southeast
        Asia is watching closely.
      </p>
    </div>
  </article>
);

export default SingaporeAIGov;
